import { MixpanelIcon } from "#components/ui/MixpanelIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const mixpanelManifest: IntegrationManifest = {
    key: "mixpanel",
    displayName: "Mixpanel",
    nameKey: "channels.mixpanel",
    descriptionKey: "mixpanelDescription",
    trayDescriptionKey: "composerTrayDescriptions.mixpanel",
    cardDescriptionKey: "connectIntegration.descriptions.mixpanel",
    connectedContentKeys: ["mixpanelReports"],
    brandColor: "#7856FF",
    iconUrl: IconAssets.Mixpanel,
    iconUrlAlt: IconAssets.MixpanelAlt,
    glyph: MixpanelIcon,
    channelType: "UserMixpanelMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
